import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as delineationActions from '../actions/delineation.actions';
import { Delineation, DelineationId } from '../types/delineation.type';

export interface DelineationState extends EntityState<Delineation> {
  selectedId?: DelineationId;
  saved?: boolean;
}

declare module 'react-redux' {
  interface DefaultRootState {
    delineation: DelineationState;
  }
}

const delineationAdapter = createEntityAdapter<Delineation>();

export const { selectAll, selectEntities, selectById } =
  delineationAdapter.getSelectors();

export default reducer(
  delineationAdapter.getInitialState(),
  on(ecgActions.clean, () => delineationAdapter.getInitialState()),
  on(
    delineationActions.load,
    (state, { delineations }): DelineationState =>
      delineationAdapter.setAll(state, delineations),
  ),
  on(delineationActions.select, (state, { delineationId }) => {
    return {
      ...state,
      selectedId: delineationId,
    };
  }),
  on(delineationActions.addDelineation, (state, { delineation }) =>
    delineationAdapter.upsertOne(state, delineation),
  ),
  on(delineationActions.setWaves, (state, { delineationId, waves }) =>
    delineationAdapter.updateOne(state, {
      id: delineationId,
      changes: { waves },
    }),
  ),
  on(delineationActions.markAsSaved, (state, _payload) => {
    return {
      ...state,
      saved: true,
    };
  }),
  on(undoActions.undo, undoActions.restore, (state, action) => {
    const {
      diff: { delineation },
    } = action;
    if (!delineation) {
      return state;
    }
    return { ...state, ...delineation };
  }),
);
